import React from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import MyProfileMUI from "../components/ProfilePage";

const MyProfile = () => {
  return (
    <Layout>
      <SidebarLayout>
        <MyProfileMUI />
      </SidebarLayout>
    </Layout>
  );
};

export default MyProfile;
